import { FormHelperText, Input, MenuItem, Select, TextareaAutosize } from "@material-ui/core"
import Button from "@material-ui/core/Button"
import FormControl from "@material-ui/core/FormControl"
import Paper from "@material-ui/core/Paper"
import Typography from "@material-ui/core/Typography"
import { Alert } from "@material-ui/lab"
import React from "react"

import { knowledgeAreaArray } from "../../Constants"
import CustomAlert from "../CustomAlert"
import EmailInputs from "../EmailInputs"

const OneAsTwo = ({ knowledgeArea, paperFile, paperFile2, paperTitle, abstract, handleChange, classes, handleAddParticipant, handleEIChange, handleEmailChange, handleFileChange, handleFileChange2, handleRemoveEmail, users }) => {
    return (
        <div className={classes.bigContainer}>
            <Paper className={classes.paper}>
                <Typography variant="h5" component="h5">
                    Inscrição como Apresentador
                </Typography>
                <Typography color="error" variant="subtitle1">ATENÇÃO: O Primeiro Autor será considerado como o Apresentador do resumo.</Typography>

                <Button variant='contained' color='primary' onClick={handleAddParticipant} style={{ margin: '15px' }}>
                    Adicionar colaborador
                </Button>
                <FormControl
                    variant="outlined"
                    className={classes.formControl}
                >
                    <Input
                        id="paperTitle"
                        placeholder="Titulo"
                        name="paperTitle"
                        value={paperTitle}
                        onChange={handleChange}
                        required
                        aria-describedby="paperTitle-helper"
                    />
                    <FormHelperText id="paperTitle-helper">Título do resumo</FormHelperText>
                </FormControl>
                {
                    users.map((val, idx) => (
                        <React.Fragment key={idx}>
                            <EmailInputs
                                handleRemoveEmail={handleRemoveEmail}
                                style={classes.formControl}
                                key={`users-${idx}`}
                                idx={idx}
                                usersState={users}
                                handleEmailChange={handleEmailChange}
                                handleEIChange={handleEIChange}
                            />
                        </React.Fragment>
                    ))
                }
                <FormControl
                    variant="outlined"
                    className={classes.formControl}
                >
                    <TextareaAutosize
                        id="abstract"
                        name="abstract"
                        placeholder="Até 250 palavras"
                        value={abstract}
                        onChange={handleChange}
                        multiline={"true"}
                        maxRows={10}
                        variant="filled"
                        aria-describedby="abstract-helper"
                    />
                    <FormHelperText id="abstract-helper">Resumo do resumo</FormHelperText>
                </FormControl>

                <FormControl
                    variant="outlined"
                    className={classes.formControl}
                >
                    <Select
                        id="knowledgeArea"
                        name="knowledgeArea"
                        value={knowledgeArea}
                        onChange={handleChange}
                        placeholder="Selecione uma Área de Conhecimento"
                        className={classes.menuItem}
                    >
                        <MenuItem value={null}>
                            <em>Selecione uma Área de Conhecimento</em>
                        </MenuItem>
                        {
                            knowledgeAreaArray.map(k => (
                                <MenuItem key={k.value} value={k.value}>{k.title}</MenuItem>
                            ))
                        }
                    </Select>
                    <FormHelperText id="knowledgeArea">Área de Conhecimento</FormHelperText>
                </FormControl>
                <CustomAlert message={"Atenção! Deverão ser entregues os dois (2) documentos: um DOCX e outro PDF. Resumos FORA DO MODELO, SERÃO REJEITADOS."} />
                <div>
                    <Typography color="error" variant="subtitle1">ATENÇÃO: O arquivo .docx é obrigatório para a submissão do resumo, COM O NOME DOS AUTORES.</Typography>
                    <FormControl
                        variant="outlined"
                        className={classes.formControl}
                    >
                        <input accept=".docx"
                            type="file"
                            name="paperFile"
                            onChange={handleFileChange}
                            placeholder="Selecione seu arquivo"
                        />
                        {
                            paperFile && (
                                <Alert severity="success">Arquivo carregado com sucesso!</Alert>
                            )
                        }
                        <FormHelperText id="my-helper-text">Arquivo em .docx</FormHelperText>
                    </FormControl>
                </div>
                <div>
                    <div>
                        <Typography color="error" variant="subtitle1">ATENÇÃO: O arquivo .pdf é obrigatório para a submissão do resumo, SEM O NOME DOS AUTORES.</Typography>
                        <FormControl
                            variant="outlined"
                            className={classes.formControl}
                        >
                            <input accept=".pdf"
                                type="file"
                                name="paperFile2"
                                onChange={handleFileChange2}
                                placeholder="Selecione seu arquivo"
                            />
                            {
                                paperFile2 && (
                                    <Alert severity="success">Arquivo carregado com sucesso!</Alert>
                                )
                            }
                            <FormHelperText id="my-helper-text">Arquivo em .pdf</FormHelperText>
                        </FormControl>
                    </div>
                </div>
            </Paper>
        </div>
    );
}

export default OneAsTwo;